import {
  FacebookLoginProvider,
  GoogleLoginProvider,
  SocialAuthServiceConfig,
} from 'angularx-social-login';

import { environment } from '@env/environment';

export const SOCIAL_AUTH_SERVICE_CONFIG: SocialAuthServiceConfig = {
  autoLogin: false,
  providers: [
    {
      id: GoogleLoginProvider.PROVIDER_ID,
      provider: new GoogleLoginProvider(environment.googleClientId),
    },
    {
      id: FacebookLoginProvider.PROVIDER_ID,
      provider: new FacebookLoginProvider(environment.facebookAppId, {
        version: environment.facebookVersion,
      }),
    },
  ],
};

export const SOCIAL_TOKENS = {
  facebook: 'token_facebook',
  google: 'token_google',
  apple: 'token_apple',
};

export const PROVIDERS = {
  facebook: 'FACEBOOK',
  google: 'GOOGLE',
  apple: 'apple',
};

export const AUTHPROVIDERS = {
  facebook: 'auth_id_facebook',
  google: 'auth_id_google',
  apple: 'auth_id_apple',
};
